import i18next from 'i18next';

i18next.addResources('es_CL', 'StartOrder', {
  startHereYourOrder: 'Comenzar pedido'
});

i18next.addResources('pt_PT', 'StartOrder', {
  startHereYourOrder: 'Iniciar pedido'
});
